import { EditChatTabNames } from '@choco-admin/types';
import { Tabs, Tab } from '@heroui/react';
import React from 'react';
import {
  FiUsers,
  FiSettings,
  FiShoppingCart,
  FiMessageSquare,
} from 'react-icons/fi';
import { useNavigate, useLocation } from 'react-router-dom';

interface EditChatTabsProps {
  activeTab: EditChatTabNames;
}

export const EditChatTabs: React.FC<EditChatTabsProps> = ({ activeTab }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleTabChange = (key: React.Key) => {
    const newTab = key as EditChatTabNames;
    navigate(`${location.pathname}#${newTab}`, { replace: true });
  };

  return (
    <Tabs
      selectedKey={activeTab}
      onSelectionChange={handleTabChange}
      variant="underlined"
      classNames={{
        tabList:
          'gap-6 w-full relative rounded-none p-0 border-b border-divider',
        cursor: 'w-full bg-primary',
        tab: 'max-w-fit px-0 h-12',
        tabContent: 'group-data-[selected=true]:text-primary',
      }}
    >
      <Tab
        key={EditChatTabNames.PARTICIPANTS}
        title={
          <div className="flex items-center gap-2">
            <FiUsers size={16} />
            <span>Participants</span>
          </div>
        }
      />
      <Tab
        key={EditChatTabNames.SETTINGS}
        title={
          <div className="flex items-center gap-2">
            <FiSettings size={16} />
            <span>Settings</span>
          </div>
        }
      />
      <Tab
        key={EditChatTabNames.ORDER_GUIDE}
        title={
          <div className="flex items-center gap-2">
            <FiShoppingCart size={16} />
            <span>Order Guide</span>
          </div>
        }
      />
      <Tab
        key={EditChatTabNames.CHAT_HISTORY}
        title={
          <div className="flex items-center gap-2">
            <FiMessageSquare size={16} />
            <span>Chat History</span>
          </div>
        }
      />
    </Tabs>
  );
};
